// usePreAuthOrg.ts — React side of agentBootstrap.js for the pre-auth pages (S2-B B2).
// Resolves the page's bot from ?id= (or, with no id, the HOST) via GET /agent-bootstrap and exposes
// one status the page renders. Never a JSON fallback, never Nova (decision A).
import { useEffect, useState } from 'react';
import { fetchAgentBootstrap, orgFromBootstrap, bootstrapBotId } from './agentBootstrap';
import type { OrgSettings } from '../tools/orgSettings';

export type PreAuthStatus = 'loading' | 'ready' | 'not-found' | 'unavailable';
export type PreAuthState = {
  status: PreAuthStatus;
  org: OrgSettings | null;
  record: any | null;
  botId: string;
  reason?: string;
};

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '') || undefined;

/** @param id the requested bot id; '' ⇒ resolve by window.location.hostname; null ⇒ do not resolve */
export function usePreAuthOrg(id: string | null): PreAuthState {
  const [state, setState] = useState<PreAuthState>({ status: 'loading', org: null, record: null, botId: id || '' });
  useEffect(() => {
    let cancelled = false;
    if (id === null) {
      setState({ status: 'not-found', org: null, record: null, botId: '', reason: 'not requested' });
      return;
    }
    const q = id ? { id } : { host: window.location.hostname };
    fetchAgentBootstrap(q, { baseUrl: API_BASE }).then((r: any) => {
      if (cancelled) return;
      if (r.status !== 'ok') {
        console.error(`[BotIdentity] pre-auth ${r.status}: ${JSON.stringify(q)} — ${r.reason}`);
        setState({ status: r.status, org: null, record: null, botId: id || '', reason: r.reason });
        return;
      }
      const botId = id || bootstrapBotId(r.record);
      setState({ status: 'ready', org: orgFromBootstrap(r.record, botId) as OrgSettings, record: r.record, botId });
    });
    return () => { cancelled = true; };
  }, [id]);
  return state;
}
